export default "__VITE_ASSET__DoEjIO_1__"